import ModalProvider from './ModalProvider'

export { useModal } from './modalContext'

export default ModalProvider
